import { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePartner } from '../../stores/partner/partner/PartnerAction';
import { usePartnerManager } from '../../stores/partner/partnermanager/PartnerManagerAction';
import { usePartnerAPI } from '../../api/partner/usePartnerAPI';
import { partnerColumns, managerColumns, partnerFormFields, managerFormFields  } from './context';

import FileManagement from '../../components/Modal/File/FileManagement'
import Table from '../../components/Table/Table/Table';
import EmptyState from '../../components/EmptyState';
import { LIST_EMPTY } from '../_shared/listEmptyState';
import BaseModal from '../../components/Modal/Base/BaseModal';
import CrudModal from '../../components/Modal/Crud/CrudModal';
import ConfirmModal from '../../components/Modal/Confirm/ConfirmModal';
import ExcelImportResultModal from '../../components/Modal/ExcelImportResult/ExcelImportResultModal';

import { PiFloppyDiskBold } from 'react-icons/pi';
import { FaInfo } from 'react-icons/fa';
import { FaHandshake } from 'react-icons/fa';
import './PartnerManagement.css';

const CustomerManagement = () => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const partners = useSelector((state) => state.partner);
  const partnerAPi = usePartner();
  const partnerManagers = useSelector((state) => state.partnerManager);
  const partnerManagerAPi = usePartnerManager();
  const partnerDirectApi = usePartnerAPI();
  const [selectedRows, setSelectedRows] = useState([]);
  const [clickedRow, setClickedRow] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [ modalTitle, setModalTitle ] =useState(null);
  const [importResult, setImportResult] = useState(null);
  const [importResultOpen, setImportResultOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const closeModal = () => {
    setIsOpen(false);
  };

  const searchPartner = (params) => {
    dispatch(partnerAPi.request.get(params));
    setClickedRow(null);
  }
  const addPartner = async (data) => {
    data.companySeq = session.companySeq;
    await partnerAPi.request.post(data)
    searchPartner({
      companySeq: session.companySeq,
      page: currentPage,
      size: 10
    });
  }
  const updatePartner = async (data) => {
    data.companySeq = session.companySeq
    // data.partnerSeq = clickedRow.partnerSeq
    await partnerAPi.request.put(data);
    searchPartner({
      companySeq: session.companySeq,
      page: currentPage,
      size: 10
    });
  }
  const deletePartner = async (row) => {
    const params = [row.partnerSeq]
    await partnerAPi.request.delete(params)
    searchPartner({
      companySeq: session.companySeq,
      page: currentPage,
      size: 10
    });
  }

  const searchPartnerManager = (params) => {
    dispatch(partnerManagerAPi.request.get(params));
  }
  
  const addPartnerManager = async (data) => {
    if (partnerManagers.data.some(item => item.userSeq === Number(data.userSeq))) {
      alert('이미 등록된 담당자입니다.');
      return;
    }
    data.companySeq = session.companySeq;
    data.partnerSeq = clickedRow.partnerSeq;
    await partnerManagerAPi.request.post(data)
    searchPartnerManager({
      companySeq: session.companySeq,
      partnerSeq: clickedRow.partnerSeq
    });
  }
  const updatePartnerManager = async (data) => {
    data.companySeq = session.companySeq
    //data.partnerManagerSeq = clickedRow.partnerManagerSeq
    await partnerManagerAPi.request.put(data)
    searchPartnerManager({
      companySeq: session.companySeq,
      partnerSeq: clickedRow.partnerSeq
    });
  }
  const deletePartnerManager = async (row) => {
    const params = [row.partnerManagerSeq]
    await partnerManagerAPi.request.delete(params)
    searchPartnerManager({
      companySeq: session.companySeq,
      partnerSeq: clickedRow.partnerSeq
    });
  }
  const handlePartnerRowClick = async (row) => {
    if (!row.partnerSeq) {
      console.error('Invalid partnerSeq row:', row);
      return;
    }
    if (clickedRow && clickedRow.partnerSeq === row.partnerSeq) {
      setClickedRow(null);
      return;
    }
    setClickedRow(row)
  };
  const openFileModal = (row) => {
    if (!row) {
      return;
    }
    setIsOpen(true);
    setContent(
      <FileManagement
        row={row}
        fileCode={"Partner"}
        onClose={closeModal} 
      />);
    setModalTitle(<><PiFloppyDiskBold size={20} style={{ marginRight: '8px' }} /> 첨부파일 관리</>);
  };
  useEffect(() => {
    try {
      const params = {
        companySeq: session.companySeq,
        page: 1,
        size: 10
      };
      searchPartner(params);
    } catch (error) {
      console.error('Error fetching Product : ', error);
    } finally {
      //setIsLoading(false);
    }
  }, [dispatch, session]);

  useEffect(() => {
    if(!clickedRow) return;
    const params = {
      companySeq: session.companySeq,
      partnerSeq: clickedRow.partnerSeq
    };
    try {
      searchPartnerManager(params);
    } catch (error) {
      console.error('Error fetching Material Sub data:', error);
    }
  }, [clickedRow]);


  const handleExcelDownload = async () => {
    await partnerDirectApi.partner.download({ companySeq: session.companySeq });
  };

  const handleExcelUpload = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.onchange = async () => {
      const files = Array.from(input.files || []);
      if (files.length === 0) return;
      const formData = new FormData();
      formData.append('file', files[0]);
      try {
        const result = await partnerDirectApi.partner.import(formData);
        if (result && result.data) {
          setImportResult(result.data);
          setImportResultOpen(true);
        }
        searchPartner({ companySeq: session.companySeq, page: currentPage, size: 10 });
      } catch (e) {
        alert('엑셀 업로드 실패');
      }
    };
    input.click();
  };

  const partnerPaging = (page) => {
    setCurrentPage(page);
    const parmas = {
      companySeq : session.companySeq,
      page : page,
      size : 10
    }
    searchPartner(parmas)
    setClickedRow(null)
  }


  const promptDelete = useCallback((row, type) => {
    if (!row) {
      return;
    }
    setModalTitle(<><FaInfo style={{ marginRight: '8px' }} /> 알림</>);
    let text;
    let action;
    if(type === 1){
      text = `'${row.partnerName}'을 거래처 목록에서\n삭제하시겠습니까?`;
      action = deletePartner;
    } else if (type === 2) {
      text = `'${row.userName}'을 담당자 목록에서\n삭제하시겠습니까?`;
      action = deletePartnerManager;
    }
    setContent(
      <ConfirmModal
        message={text}
        onConfirmAction={() => {
          action(row);
          closeModal();
        }}
        onCancelAction={closeModal} 
        confirmText="삭제"
        cancelText="취소"
      />);
    setIsOpen(true); 
  }, [deletePartner, closeModal, setContent, setIsOpen, setModalTitle]);

  // type 1 : 등록, 2 : 수정
  // category : 1 = 거래처, 2 = 담당자
  const openModal = (type, category, row = null) => {
    let action;
    let formFields
    if(category === 1){
      formFields = partnerFormFields;
      if(type === 1){
        setModalTitle(<><FaHandshake style={{ marginRight: '8px' }} /> 거래처 등록</>)
        action = addPartner;
      } else {
        setModalTitle(<><FaHandshake style={{ marginRight: '8px' }} /> 거래처 수정</>)
        action = updatePartner;
      }
    } else {
      formFields = managerFormFields
      if(type === 1){
        setModalTitle(<><FaHandshake style={{ marginRight: '8px' }} /> 담당자 등록</>)
        action = addPartnerManager;
      } else{
        setModalTitle(<><FaHandshake style={{ marginRight: '8px' }} /> 담당자 수정</>)
        action = updatePartnerManager;
      }
    }
    setIsOpen(true);
    setContent(
    <CrudModal
      type={type}
      formFields={formFields}
      formDatas={row || {}}
      onClose={closeModal}
      onSubmit={action}
    />);
  };

  // const [statusData, setStatusData] = useState([
  //   { id: 1, label: '수주 진행 (건)', value: 3 },
  //   { id: 2, label: '발주 진행(건)', value: 1 },
  //   { id: 3, label: '수주 미마감(건)', value: 1 },
  //   { id: 4, label: '대금 미지급(건)', value: 1 },
  // ]);

  // const [selectedCustomer, setSelectedCustomer] = useState(null);

  // const handleCustomerClick = (customer) => {
  //   setSelectedCustomer(customer);
  //   // 여기에 상세 보기 로직 추가
  // };


  return (
    <div className="customer-management">
      <div className="customer-table-container">
        <Table
          className="customer-table"
          title={<><FaHandshake style={{ marginRight: '8px' }} /> 거래처 </>}
          columns={partnerColumns(openModal, promptDelete, openFileModal)} 
          data={ partners.data }
          page={ partners.page }
          onAddClick={() => openModal(1, 1)}
          onRowClick={handlePartnerRowClick}
          paging={ partnerPaging }
          showSearchBar={false}
          excelExport={handleExcelDownload}
          excelImport={handleExcelUpload}
          emptyState={
            (partners.data?.length ?? 0) === 0 ? (
              <EmptyState
                message={LIST_EMPTY.partner.message}
                hint={LIST_EMPTY.partner.hint}
                ctaLabel={LIST_EMPTY.partner.ctaLabel}
                onCta={() => openModal(1, 1)}
              />
            ) : null
          }
        />
      </div>
      { clickedRow && (
      <div className="bottom-tables-container">
        <div className="left-table-customer">
          <Table
            className="contact-person-table"
            title="거래처 담당자 등록"
            columns={managerColumns(openModal, promptDelete)} 
            data={partnerManagers.data} 
            onAddClick={() => openModal(1, 2)}
            showSearchBar={false}
          />
        </div>
        {/*  
        
        현황판 추후 개발 예정
        <div className="right-table-customer">
          <Table 
            columns={statusColumns} 
            data={statusData} 
            className="status-table"
            title="현황판"
            showSearchBar = {false}
          />
        </div> */}
      </div>
      )}
      <BaseModal
        children={content}
        title={modalTitle}
        isOpen={isOpen}
        onClose={closeModal}
      />
      <ExcelImportResultModal
        isOpen={importResultOpen}
        onClose={() => setImportResultOpen(false)}
        result={importResult}
      />
    </div>
  );
};

export default CustomerManagement;